import {useValue} from '../../hooks';
import {Label, SelectRoot, SelectContent, SelectField, SelectOption} from './index.styled';
import {
	SubjectTab,
} from '@esgi/contracts/esgi/types/esgi.assets/endpoints/esgi.apigateway/teachers/pages/home/sections/subjects/init/subject-tab';
import {useEffect} from 'react';

interface Props {
	subjects: SubjectTab[];
	selected?: SubjectTab;
	disabled?: boolean;
	onChange: (data: SubjectTab) => void;
}

export function SubjectTabControl({subjects, disabled, onChange, selected}: Props) {
	const [subjectTab, setSubjectTab] = useValue<SubjectTab>(null, onChange);

	return (
		<SelectRoot
			value={selected ? selected.id.toString() : subjectTab?.id.toString()}
			disabled={disabled}
			onValueChange={(value) => {
				setSubjectTab(subjects.find(x => x.id.toString() === value));
			}}
		>
			<SelectField placeholder='Subject Tab'/>
			<SelectContent>
				{subjects.map(({id, name}) => (
					<SelectOption
						key={id}
						value={id.toString()}
					>
						<Label size='medium' bold>{name}</Label>
					</SelectOption>
				))}
			</SelectContent>
		</SelectRoot>
	);
}
